import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createCalendarToken, deleteCalendarToken, getCalendarToken, queryCalendarTokens, updateCalendarToken } from '@wix/ambassador-individual-scheduling-assistant-v1-calendar-token/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { CalendarTokenClientV2Base } from './CalendarTokenClientV2Base';
export class CalendarTokenClientV2 extends HttpBaseClient(CalendarTokenClientV2Base) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getCalendarTokenImpl", getCalendarToken);
    _defineProperty(this, "queryCalendarTokensImpl", queryCalendarTokens);
    _defineProperty(this, "createCalendarTokenImpl", createCalendarToken);
    _defineProperty(this, "updateCalendarTokenImpl", updateCalendarToken);
    _defineProperty(this, "deleteCalendarTokenImpl", deleteCalendarToken);
  }
}
//# sourceMappingURL=CalendarTokenClientV2Http.js.map